import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default function getReturnReasons(component) {
  const Authorization = "bearer " + localStorage.getItem("token");
  fetch(`${API_URL}rest/V1/picker/getReasons`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      user_type: "rider",
      reason_type: "return",
    }),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (result) {
      console.log("getReturnReasons", result);
      if (result && result[0] && result[0].data && result[0].data.reasons) {
        component.props.actionGetReturnReasons(result[0].data.reasons);
      }
    });
  // parentComponent.setState({ isLoading: false });
}



// WEBPACK FOOTER //
// ./src/utility/api/getReturnReasons.js